import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

const PreRegistration = () => {
  const { t } = useLanguage();
  const sectionCopy = t('preRegistration', {});
  const features = Array.isArray(sectionCopy.features) ? sectionCopy.features : [];
  const benefits = Array.isArray(sectionCopy.benefits) ? sectionCopy.benefits : [];
  const trustIndicators = Array.isArray(sectionCopy.trust) ? sectionCopy.trust : [];

  return (
    <section className="section-padding bg-gray-50">
      <div className="container-max">
        <div className="max-w-4xl mx-auto text-center text-gray-900">
          {/* Main Heading */}
          <div className="mb-8">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-6">
              {sectionCopy.title}
            </h2>
            <p className="text-lg sm:text-xl md:text-2xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              {sectionCopy.description}
            </p>
          </div>

          {/* Features Grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
            {features.map((feature) => (
              <div key={feature.title} className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4 mx-auto">
                  <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
                  </svg>
                </div>
                <h3 className="text-xl font-semibold mb-3 text-gray-900">{feature.title}</h3>
                <p className="text-gray-600 text-sm">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-8">
            <Link
              to="/auth/register"
              className="group bg-blue-600 text-white hover:bg-blue-700 text-lg px-8 py-4 rounded-lg font-semibold transition-all duration-200 flex items-center gap-3 shadow-md hover:shadow-lg"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
              </svg>
              {sectionCopy.cta?.primary || 'Pre-Register'}
            </Link>
            
            <Link
              to="/auth/login"
              className="group bg-gray-100 text-gray-700 hover:bg-gray-200 text-lg px-8 py-4 rounded-lg font-semibold transition-all duration-200 flex items-center gap-3 border border-gray-300"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1" />
              </svg>
              {sectionCopy.cta?.secondary || 'Already registered?'}
            </Link>
          </div>

          {/* Benefits List */}
          <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm text-left max-w-2xl mx-auto">
            <h3 className="text-xl font-semibold mb-4 text-center text-gray-900">
              {sectionCopy.benefitsTitle}
            </h3>
            <ul className="space-y-2 text-gray-600">
              {benefits.map((benefit) => (
                <li key={benefit} className="flex items-center gap-3">
                  <svg className="w-5 h-5 text-green-500 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  <span>{benefit}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Trust Indicators */}
          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-6 text-gray-600">
            {trustIndicators.map((item, index) => (
              <div key={item} className="flex items-center gap-2">
                <svg className={`w-5 h-5 ${index === 0 ? 'text-blue-500' : index === 1 ? 'text-green-500' : 'text-red-500'}`} fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                <span className="text-sm">{item}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PreRegistration;
